module.exports = __webpack_public_path__ + "img/tgo-intro.820febe6.png";